/* eslint-disable */
export default {
    state: {
        userdata: {},
        token: '',
    },
    getters: {},
    mutations: {
        userdata(state, val) {
            state.userdata = val
        },
        token(state, val) {
            state.token = val
        },
    },
    actions: {},
}